export default {
  ordersBreadcrumbTitle: {
    id: 'buyback_refurbisher_transactional_orders_breadcrumb_title',
    defaultMessage: 'Orders',
  },
  toastClose: {
    id: 'buyback_my_sales_ship_item_shipping_step_toast_close',
    defaultMessage: 'Close',
  },
  paymentSuccessTitle: {
    id: 'buyback_refurbisher_transactional_payment_toast_success_title',
    defaultMessage: 'Payment sent ✔',
  },
  paymentSuccessMessage: {
    id: 'buyback_refurbisher_transactional_payment_toast_success_message',
    defaultMessage: 'You’re good to go.',
  },
  errorTitle: {
    id: 'buyback_refurbisher_transactional_payment_toast_error_title',
    defaultMessage: 'Oh no!',
  },
  errorMessage: {
    id: 'buyback_refurbisher_transactional_payment_toast_error_message',
    defaultMessage: 'Something went wrong. Try again later.',
  },
  breadcrumb: {
    id: 'breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb',
  },
}
